import ServiceRequests from './containers/Admin/ServiceRequests/ServiceRequests';
import ServiceRequestsForm from './containers/Admin/ServiceRequests/ServiceRequestsForm';
import Setting from './assets/img/setting.svg';
import GuestRosterMain from './containers/Admin/Roster/GuestComponents/GuestRosterMain';

const customerRoutes = [
    {
        path: '/serviceRequests',
        layout: '/guest',
        icon: Setting,
        name: 'Service Requests',
        component: ServiceRequests,
        allowed: _ => {
            return true;
        }, 
        hasChildRoutes:true,
        childRoutes:[
            {
                path: 'serviceRequests/add',
                layout: '/guest',
                name: 'Add orders',
                component: ServiceRequestsForm,
                allowed: _ => {
                    return true;
                },
            },
            {
                path: 'serviceRequests/:id',
                layout: '/guest',
                name: 'Update orders',
                component: ServiceRequestsForm,
                allowed: _ => {
                    return true;
                },
            }
        ]
    },
    {
        path: '/roster',
        layout: '/guest',
        icon: Setting,
        name: 'Roster',
        component: GuestRosterMain,
        allowed: _ => {
            return true;
        }, 
        hasChildRoutes:false,
    }
];
export default customerRoutes;
